import { type ImageInfo } from "@client/content/types";
import { getAssetUrl } from "@client/lib/assets";
import { getImage } from "@client/lib/settings";
import {
  createShallowEqualSelector,
  getSettingSelector,
  getSettingValueSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";
import { MediaType } from "@client/types";
import { type Tag } from "@client/types/Tag";

export const makeImageInfoSelector = (target: string, propName: string = "image"): SettingsPropsParametricSelector => {
  const settingSelector = getSettingSelector(target, propName);

  return createShallowEqualSelector(
    [settingSelector],
    (image): ImageInfo => ({
      resizedUrl: getAssetUrl(getImage(image, false), MediaType.Image),
      originalUrl: getAssetUrl(getImage(image, true), MediaType.Image)
    })
  );
};

export const makeTagsSelector = () => {
  const tagsSelector = getSettingValueSelector(TargetSelector.Entity, "tags");

  return createShallowEqualSelector([tagsSelector], (tags): Tag[] =>
    (tags || "")
      .toString()
      .split(",")
      .map((t) => ({ id: t, text: t }))
  );
};
